export const DASH = '—';

// sync: из BAS — графический баг колонки «Отмены».
// Источник данных иногда пишет в номер документа (№ отмены и т.п.) литеральный
// плейсхолдер «-» (или «–»/«—»). JS `||` его не отсекает (непустая строка — truthy),
// из-за чего в таблицах вместо номера показывался голый дефис, а в идентификатор
// скачивания попадал «-» (поиск PDF по нему цеплял чужую строку региона). Считаем
// такой плейсхолдер «пустым» — вызывающий код делает фоллбэк на № реестра.
const PLACEHOLDER_DOC_NUMBERS = new Set(['-', '–', '—']);
export const cleanDocNumber = (value?: string | number | null): string => {
  const s = String(value ?? '').trim();
  return PLACEHOLDER_DOC_NUMBERS.has(s) ? '' : s;
};

export const formatNullable = (value: unknown, fallback: string = DASH): string => {
  if (value === null || value === undefined || value === '') return fallback;
  return String(value);
};

// "1 000" (целое) или "1 000.50" (если есть копейки). Пробел — разделитель тысяч.
export const formatMoney = (value: unknown, fallback: string = DASH): string => {
  if (value === null || value === undefined || value === '') return fallback;
  const num = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(num)) return fallback;
  const isInteger = Number.isInteger(num);
  const formatted = isInteger ? num.toFixed(0) : num.toFixed(2);
  const [intPart, decPart] = formatted.split('.');
  const intWithSep = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return decPart ? `${intWithSep}.${decPart}` : intWithSep;
};

// "21.05.2026"
export const formatDate = (value: string | Date | null | undefined, fallback: string = DASH): string => {
  if (!value) return fallback;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return fallback;
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${dd}.${mm}.${yyyy}`;
};

// "21.05.2026 14:30"
export const formatDateTime = (value: string | Date | null | undefined, fallback: string = DASH): string => {
  if (!value) return fallback;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return fallback;
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, '0');
  const min = String(d.getMinutes()).padStart(2, '0');
  return `${dd}.${mm}.${yyyy} ${hh}:${min}`;
};
